const {
    VITE_APP_API_ROOT,
    VITE_APP_DEV_PLAN_MASTER,
    VITE_APP_STAGING_PLAN_MASTER,
    VITE_APP_CAR_ORDER,
    VITE_APP_USER_PROFILE,
    VITE_APP_PLATFORM_SERVICE,
} = import.meta.env

async function client(route, options, baseUrl, customHeaders) {
    let URL = getBaseUrl(baseUrl)
    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
        ...customHeaders,
    }

    if (localStorage.getItem("okta-token-storage"))
        headers["Authorization"] =
            "Bearer " +
            JSON.parse(localStorage.getItem("okta-token-storage")).accessToken
                .accessToken

    const defaultOptions = { headers }
    const response = await fetch(`${URL}/${route}`, {
        ...defaultOptions,
        ...options,
        redirect: "manual",
    })
    try {
        if (response.status === 204) return response.text()
        if (
            response.ok &&
            response.status === 200 &&
            response.headers.get("Content-Length") === "0"
        )
            return null
        else if (response.ok || response.status === 200) return response.json()
        const responseJson = await response.json()
        const error = new Error(responseJson.message || responseJson.error)
        error.status = response.status
        throw error
    } catch (e) {
        return Promise.reject(e)
    }
}

const api = {
    get(route, baseUrl, customHeaders) {
        return client(
            route,
            {
                method: "GET",
            },
            baseUrl,
            customHeaders
        )
    },

    post(route, data, baseUrl, customHeaders) {
        return client(
            route,
            {
                method: "POST",
                body: JSON.stringify(data),
            },
            baseUrl,
            customHeaders
        )
    },

    put(route, data, baseUrl, customHeaders) {
        return client(
            route,
            {
                method: "PUT",
                body: JSON.stringify(data),
            },
            baseUrl,
            customHeaders
        )
    },

    delete(route, baseUrl, customHeaders) {
        return client(
            route,
            {
                method: "DELETE",
            },
            baseUrl,
            customHeaders
        )
    },
}

const getBaseUrl = (base) => {
    let URL = VITE_APP_API_ROOT
    if (base === "ROOT") {
        URL = VITE_APP_API_ROOT
    } else if (base === "MASTER") {
        URL = VITE_APP_DEV_PLAN_MASTER
    } else if (base === "STAGING") {
        URL = VITE_APP_STAGING_PLAN_MASTER
    } else if (base === "CAR_ORDER") {
        URL = VITE_APP_CAR_ORDER
    } else if (base === "USER_PROFILE") {
        URL = VITE_APP_USER_PROFILE
    } else if (base === "PLATFORM_SERVICE") {
        URL = VITE_APP_PLATFORM_SERVICE
    }
    return URL
}

export default api
